import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IAdConnectionDto, IResult } from "../models/auto-generated";

@Injectable({
  providedIn: "root"
})
export class ActiveDirectoryConnectionService {
  private getBaseRoute(instanceId: string): string {
    return `/api/configurations/${instanceId}/active-directory`;
  }
  constructor(private http: HttpClient) {}

  getConnection(instanceId: string): Observable<IAdConnectionDto> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.get<IAdConnectionDto>(baseRoute);
  }

  testConnection(instanceId: string, connection: IAdConnectionDto): Observable<IResult> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.post<IResult>(`${baseRoute}/test`, connection);
  }

  upsertConnection(instanceId: string, connection: IAdConnectionDto): Observable<any> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.put<any>(baseRoute, connection);
  }
}
